<div class="name">{{dragHelper.getName()}}</div>